import {VehicleCategory} from '../../interfaces/vehicles/vehicle-category';

export class VehicleCategoryFactory {
  /**
   *
   * @param vehicleCategory
   */
  public static fromObject(vehicleCategory: any): VehicleCategory {
    return new class implements VehicleCategory {
      id: number = vehicleCategory.id;
      name: string = vehicleCategory.name;
      isPrivate: boolean = vehicleCategory.is_private;
    };
  }

  /**
   *
   * @param vehicleCategories
   */
  public static fromArray(vehicleCategories: any[]): VehicleCategory[] {
    return vehicleCategories.map(_vehicleCategory => VehicleCategoryFactory.fromObject(_vehicleCategory));
  }
}
